import { IVALID_TYPES, VALID_TYPES } from '@src/constants';

type ApptTypesSet = Set<string>;
type ClinicType = string;

type DisablingApptTypeFn = (apptTypesSet: ApptTypesSet, clinicType: ClinicType, lcApptType: string) => boolean;

export const disableApptTypeForHeroBtns: DisablingApptTypeFn = (apptTypesSet, clinicType, lcApptType) =>
	(lcApptType === 'workplace' && !(apptTypesSet.has('om-complex') || apptTypesSet.has('om-standard'))) ||
	(lcApptType !== 'other' && lcApptType !== 'workplace' && !apptTypesSet.has(lcApptType)) ||
	(lcApptType === 'other' && clinicType !== 'UNIVERSITY' && !apptTypesSet.has('illness')) ||
	(lcApptType === 'other' && clinicType === 'UNIVERSITY');

export const disableApptTypeForDropdown: DisablingApptTypeFn = (apptTypesSet, clinicType, lcApptType) =>
	disableApptTypeForHeroBtns(apptTypesSet, clinicType, lcApptType) ||
	(lcApptType === 'injury' && clinicType === 'UNIVERSITY');

/**
 * Creates a function that determines whether a particular appointment type is available
 * Used by LocationFilter component
 */
export const availableValidType =
	(apptTypesSet: ApptTypesSet, clinicType: ClinicType, disablingFn: DisablingApptTypeFn) =>
	({ lcApptType, ...rest }: IVALID_TYPES) => ({
		...rest,
		lcApptType,
		disabled: disablingFn(apptTypesSet, clinicType, lcApptType),
	});

export const validateTagsGen = (
	availableKeys: string[],
	clinicType: string,
	disablingFn: DisablingApptTypeFn
): IVALID_TYPES[] => {
	const apptTypesSet = new Set(availableKeys.map((key) => key.toLowerCase()));

	return VALID_TYPES.map(availableValidType(apptTypesSet, clinicType, disablingFn)).filter(
		({ lcApptType, showWhenAbsent }) => showWhenAbsent || apptTypesSet.has(lcApptType)
	);
};

/**
 * Validates appt types for HeroLocation component
 */
export const validateTags = (availableKeys: string[], clinicType = 'URGENT_CARE'): IVALID_TYPES[] =>
	validateTagsGen(availableKeys, clinicType, disableApptTypeForHeroBtns);

/**
 * Validates appt types for LocationFilter component
 */
export const validateTagsForFilter = (availableKeys: string[], clinicType = 'URGENT_CARE'): IVALID_TYPES[] =>
	validateTagsGen(availableKeys, clinicType, disableApptTypeForDropdown);
